import { IImage, TBentoCard, TBentoGrid, THrefLink, TSubtitle, TTestimony } from "./common";
import { TFaq, TVacancyCard } from "./entities";
import { TGridCard, THomeHeroSearchBar } from "./features";

export enum WidgetsComponent {
  HomeHeroSection = "widgets.home-hero-section",
  VacancyRecommendationSection = "widgets.vacancy-recommendation-section",
  PopularJobFunctionSection = "widgets.popular-job-function-section",
  HomeBentoGridSection = "widgets.home-bento-grid-section",
  TestimonySection = "widgets.testimony-section",
  VacancyCtaSection = "widgets.vacancy-cta-section",
  CommonHeroSection = "widgets.common-hero-section",
  VacancyCarouselSection = "widgets.vacancy-carousel-section",
  CommonBentoGridSection = "widgets.common-bento-grid-section",
  CommonGridSection = "widgets.common-grid-section",
  FaqSection = "widgets.faq-section",
  EmployerCta = "widgets.employer-cta",
}

export type THomeHeroSection = {
  id: number;
  title: string;
  subtitle: string;
  leftBannerDesktop?: IImage;
  leftBannerMobile?: IImage;
  rightBannerDesktop?: IImage;
  rightBannerMobile?: IImage;
  searchbar: THomeHeroSearchBar;
  __component: WidgetsComponent.HomeHeroSection;
}

export type TVacancyRecommendationSection = {
  id: number;
  title: string;
  description: string;
  moreButton: THrefLink;
  vacancyCard: TVacancyCard;
  __component: WidgetsComponent.VacancyRecommendationSection;
}

export type TPopularJobFunctionSection = {
  id: number;
  title: string;
  footnote: string;
  button: THrefLink;
  __component: WidgetsComponent.PopularJobFunctionSection;
}

export type THomeBentoGridSection = {
  id: number;
  colSize: "one" | "two";
  backgroundColor: "gray" | "white";
  cards: TBentoCard[];
  __component: WidgetsComponent.HomeBentoGridSection;
}

export type TTestimonySection = {
  id: number;
  title: string;
  description?: string;
  testimonies: TTestimony[];
  __component: WidgetsComponent.TestimonySection;
}

export type TVacancyCtaSection = {
  id: number;
  title: string;
  description?: string;
  button?: THrefLink;
  image: IImage;
  backgroundDesktop: IImage;
  backgroundMobile: IImage;
  __component: WidgetsComponent.VacancyCtaSection;
}

export type TCommonHeroSection = {
  id: number;
  title: string;
  description?: string;
  subtitle?: TSubtitle;
  button?: THrefLink;
  imageDesktop: IImage;
  imageMobile: IImage;
  backgroundMobile?: IImage;
  direction: "ltr" | "rtl";
  __component: WidgetsComponent.CommonHeroSection;
}

export type TVacancyCarouselSection = {
  id: number;
  title: string;
  moreButton?: THrefLink;
  vacancyCard: TVacancyCard;
  __component: WidgetsComponent.VacancyCarouselSection;
}

export type TCommonBentoGridSection = {
  id: number;
  title: string;
  subtitle: string;
  backgroundColor: "gray" | "white";
  colSize: "one" | "two";
  grids: TBentoGrid[];
  footnote?: string;
  button?: THrefLink;
  __component: WidgetsComponent.CommonBentoGridSection;
}

export type TCommonGridSection = {
  id: number;
  title: string;
  subtitle?: TSubtitle;
  cards?: TGridCard[];
  __component: WidgetsComponent.CommonGridSection;
}

export type TFaqSection = {
  id: number;
  title: string;
  description?: string;
  subtitle?: TSubtitle;
  footnote?: string;
  footLink?: THrefLink;
  faqs: TFaq[];
  __component: WidgetsComponent.FaqSection;
}

export type TEmployerCta = {
  id: number;
  title: string;
  description?: string;
  button?: THrefLink;
  backgroundDesktop: IImage;
  backgroundMobile: IImage;
  __component: WidgetsComponent.EmployerCta;
}